
import * as cloudflareRuntime$_J9pQVZt8Nn103MNu3EwJJIWeWm5VnoCIRsEJQoIJvM from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_db0@0.3.2_better-sqlite3@11.10.0_dri_1c385e542f6f0b8b83e47ed636dc8c8c/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as ipxRuntime$AQh5O8U3vKIve2yYl_yIKjjtUMOYcNqfbKi7JC_lDYk from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_db0@0.3.2_better-sqlite3@11.10.0_dri_1c385e542f6f0b8b83e47ed636dc8c8c/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$x5vwo6Xgz8LiFa5itDAFhNjMXpptayO8hQtrqGxm4w4 from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_db0@0.3.2_better-sqlite3@11.10.0_dri_1c385e542f6f0b8b83e47ed636dc8c8c/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$_J9pQVZt8Nn103MNu3EwJJIWeWm5VnoCIRsEJQoIJvM, defaults: {"baseURL":"https://nuxt.com"} },
  ['ipx']: { provider: ipxRuntime$AQh5O8U3vKIve2yYl_yIKjjtUMOYcNqfbKi7JC_lDYk, defaults: {"baseURL":"https://ipx.nuxt.com"} },
  ['none']: { provider: noneRuntime$x5vwo6Xgz8LiFa5itDAFhNjMXpptayO8hQtrqGxm4w4, defaults: {} }
}
        